import {getTranslationList} from "@/api/sys/common";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en-US', // 默认语言
    fallbackLocale: 'en-US',
    silentTranslationWarn: true,
});

// 动态加载语言文件的函数
// 设置语言文件
async function setLocaleMessages(locale) {

    let messages = {}
    let messagesEnglish = {}
    let messagesVant = {}

    try {
        messagesEnglish = (await import(`./langs/en-US.js`)).default;
        messages = (await import(`./langs/${locale}.js`)).default;
        messagesVant = (await import(`./vant/${locale}.ts`)).default;
    } catch (e) {
        console.error(e)
    }
    const transList = (await getTranslationList()).data;
    let messagesBack = {}
    transList.forEach(item => {
         messagesBack[item.code] = item.content
    })
    let content = {...messagesEnglish, ...messagesVant, ...messages, ...messagesBack};
    // console.log('content',content)
    // console.log('messagesBack',messagesBack)
    i18n.setLocaleMessage(locale, content);
    // vant-ui 切换语言
    vant.Locale.use(locale, messagesVant)
};

// 注册 i18n 的动态切换语言函数
i18n.changeLanguage = async (locale) => {
    console.log('changeLanguage ', locale)
    await setLocaleMessages(locale);
    i18n.locale = locale;
};
// element-ui 切换语言
ELEMENT.locale((key, value) => i18n.t(key, value)) //方便element使用，其内部封装也是采用的i18n

export default i18n;
